import React from 'react';
import { Modal } from 'antd';

import { VideoPlayer } from '@/components/ui/@DesignSystem/VideoPlayer';

import { ModalTitle, VideoBox } from './styles';

const MODAL_WIDTH = '58rem';

interface VideoModalProps {
	title: string;
	url: string;
	onClose: () => void;
}

export function VideoModal({ title, url, onClose }: Readonly<VideoModalProps>): JSX.Element {
	return (
		<Modal open centered destroyOnClose footer={null} width={MODAL_WIDTH} onCancel={onClose}>
			<ModalTitle>{title}</ModalTitle>
			<VideoBox>
				<VideoPlayer src={url} showVolume={false} showMinimize={false} showCloseButton={false} />
			</VideoBox>
		</Modal>
	);
}
